module.exports = __webpack_public_path__ + "static/media/gycsado.cdfd32ed.jpg";